import {Component, inject, OnInit} from '@angular/core';
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {DialogHelper} from '../../../../shared/helper/dialog-helper';
import {PlayerProfile} from '../../../model/player-profile';
import {DialogButtonComponent} from '../../../../shared/common/dialog-button/dialog-button.component';
import {RestErrorHelper} from '../../../../../helper/rest-error-helper';
import {PlayerProfileService} from '../../../service/player-profile.service';
import {CheckboxComponent} from '../../../../../components/abstract/checkbox/checkbox.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {Textarea} from 'primeng/textarea';
import {Divider} from 'primeng/divider';
import {InputText} from 'primeng/inputtext';
import {Avatar} from 'primeng/avatar';
import {environment} from '../../../../../../environments/environment';

@Component({
  selector: 'app-player-profile-report-picture-dialog',
  imports: [
    DialogButtonComponent,
    TranslatePipe,
    CheckboxComponent,
    ReactiveFormsModule,
    Textarea,
    FormsModule,
    Divider,
    InputText,
    Avatar
  ],
  templateUrl: './player-profile-report-picture-dialog.component.html',
  styleUrl: './player-profile-report-picture-dialog.component.scss'
})
export class PlayerProfileReportPictureDialogComponent implements OnInit
{
  private ref = inject(DynamicDialogRef);
  private config = inject(DynamicDialogConfig);
  private restErrorHelper = inject(RestErrorHelper);
  private playerProfileService = inject(PlayerProfileService);

  playerProfile: PlayerProfile;
  policyAccepted: boolean;
  isSaving: boolean;
  text: string;
  name: string;
  mail: string;

  public static openDialog(dialogService: DialogService, playerProfile: PlayerProfile,
                           translate: TranslateService): DynamicDialogRef
  {
    return dialogService.open(
      PlayerProfileReportPictureDialogComponent,
      DialogHelper.createBasicConfig({
        header: translate.instant('REPORT_PICTURE'),
        width: DialogHelper.getDialogWidth(700),
        // height: '80%',
        data: {playerProfile},
        styleClass: 'dynamicDialog'
      }));
  }

  ngOnInit(): void
  {
    this.playerProfile = this.config.data.playerProfile;
    console.log('Init PlayerProfileReportPictureDialogComponent: ', this.playerProfile);
  }

  onOkClicked(): void
  {
    if (this.isSaving || !this.policyAccepted || !this.text)
      return;

    this.isSaving = true;
    const body = {
      reportText: this.text,
      reportName: this.name,
      reportMail: this.mail,
      reportPictureFilename: this.playerProfile.pictureFilename,
      playerProfile: {
        id: this.playerProfile.id
      }
    };

    this.playerProfileService.reportPicture(body).subscribe({
      next: data =>
      {
        console.log('Meldung erfolgreich', data);
        this.isSaving = false;
        this.ref.close(true);
        this.restErrorHelper.showInfoMessageService('REPORT_PICTURE_SUCCESS', environment.toastDurationLong);
      },
      error: error =>
      {
        this.isSaving = false;
        this.restErrorHelper.handleErrorService(error);
      }
    });
  }

  onCancelClicked(): void
  {
    if (!this.isSaving)
      this.ref.close(false);
  }
}
